import camelcaseKeys from 'camelcase-keys';
import { v4 as uuid } from 'uuid';

import { type Library } from 'api/types/Library';
import { type RawLibrary } from 'api/types/Library/RawLibrary';

import { convertImgixUrl } from 'helpers/convertImgixUrl';

const parseImage = (src: string | null) => {
  if (src === null) {
    return null;
  }

  if (src.includes('jwplayer')) {
    return src.replace(/^https/, 'http');
  }

  return convertImgixUrl(src);
};

export const parseLibrary = (rawData: RawLibrary) => {
  const data = camelcaseKeys({ ...rawData }, { deep: true });

  const thumbnail =
    data.thumbnail === undefined && data.image !== undefined
      ? parseImage(data.image || null)
      : parseImage(data.thumbnail || null);

  const output: Library = {
    chapter: {
      id: data.chapter?.id || 0,
      image: data.chapter?.chapterImage || '',
      number: data.chapter?.chapterNumber || 0,
      title: data.chapter?.chapterTitle || '',
    },
    description: null,
    excludeFile: Boolean(data.excludeFile || 0),
    id: (data?.id || data?.pageId || uuid())?.toString(),
    // link: data.link, // Pretty sure this value is always the same as `url`, uncomment if needed
    linkJw: data.linkJw || null,
    shareable: Boolean(data.shareable || 0),
    textHtml: data.textHtml || null,
    thumbnail: thumbnail as string, // thumbnail/image can be undefined, but in practice it's never both
    title: data.title || null,
    type: data.type,
    url: data.url || data.link || '',
  };

  Object.keys(output).forEach((k) => {
    const key = k as keyof typeof output;
    const value = output[key];

    if (typeof value === 'string' && value.length === 0) {
      (output[key] as string | null) = null;
    }
  });

  return output;
};
